import React, { useState, useEffect } from 'react';
import SemesterTranscript from './SemesterTranscript';
import { GeTranscript } from './API'

const Transcript = () => {

    const [data, setData] = useState([])
    useEffect(() => {
        GeTranscript()
            .then(data => {
                 setData(data);
            })
    }, [])

    return (
        <div id="div_main" class="col-xs-12 col-md-12">
            <div class="card">
						<div class="card-block">
							<h4 class="card-title m-t-0">Transcript</h4>
							<p class="card-text">
                            
                                Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                            <div class="row">
                                <div class="col-12 col-md-4"></div>
                                <div class="col-12 col-md-4">

                                <button id="DownloadTranscript" onclick="DownloadTranscript();" class="btn btn-md btn-primary btn-block">Download un Official Transcript</button>
                                </div>
                            </div>
							
						</div>
					</div>
           
{data.map(item => <SemesterTranscript item={item} key={item.batchName}/>)}







            
















        </div>
    );
};

export default Transcript;


// WEBPACK FOOTER //
// ./src/pages/Transcript/Transcript.js